export const currencies = [
  { value: "AED", label: "United Arab Emirates Dirham", flag: "AE" },
  { value: "AFN", label: "Afghan Afghani", flag: "AF" },
  { value: "ALL", label: "Albanian Lek", flag: "AL" },
  { value: "AMD", label: "Armenian Dram", flag: "AM" },
  { value: "ANG", label: "Netherlands Antillean Guilder", flag: "AN" },
  { value: "AOA", label: "Angolan Kwanza", flag: "AO" },
  { value: "ARS", label: "Argentine Peso", flag: "AR" },
  { value: "AUD", label: "Australian Dollar", flag: "AU" },
  { value: "AWG", label: "Aruban Florin", flag: "AW" },
  { value: "AZN", label: "Azerbaijani Manat", flag: "AZ" },
  { value: "BAM", label: "Bosnia-Herzegovina Convertible Mark", flag: "BA" },
  { value: "BBD", label: "Barbadian Dollar", flag: "BB" },
  { value: "BDT", label: "Bangladeshi Taka", flag: "BD" },
  { value: "BGN", label: "Bulgarian Lev", flag: "BG" },
  { value: "BHD", label: "Bahraini Dinar", flag: "BH" },
  { value: "BIF", label: "Burundian Franc", flag: "BI" },
  { value: "BMD", label: "Bermudan Dollar", flag: "BM" },
  { value: "BND", label: "Brunei Dollar", flag: "BN" },
  { value: "BOB", label: "Bolivian Boliviano", flag: "BO" },
  { value: "BRL", label: "Brazilian Real", flag: "BR" },
  { value: "BSD", label: "Bahamian Dollar", flag: "BS" },
  { value: "BTN", label: "Bhutanese Ngultrum", flag: "BT" },
  { value: "BWP", label: "Botswanan Pula", flag: "BW" },
  { value: "BYN", label: "New Belarusian Ruble", flag: "BY" },
  { value: "BYR", label: "Belarusian Ruble", flag: "BY" },
  { value: "BZD", label: "Belize Dollar", flag: "BZ" },
  { value: "CAD", label: "Canadian Dollar", flag: "CA" },
  { value: "CDF", label: "Congolese Franc", flag: "CD" },
  { value: "CHF", label: "Swiss Franc", flag: "SZ" },
  { value: "CLF", label: "Chilean Unit of Account (UF)", flag: "AF" },
  { value: "CLP", label: "Chilean Peso", flag: "CL" },
  { value: "CNY", label: "Chinese Yuan", flag: "CN" },
  { value: "COP", label: "Colombian Peso", flag: "CO" },
  { value: "CRC", label: "Costa Rican Col\u00f3n", flag: "CR" },
  { value: "CUC", label: "Cuban Convertible Peso", flag: "CU" },
  { value: "CUP", label: "Cuban Peso", flag: "CU" },
  { value: "CVE", label: "Cape Verdean Escudo", flag: "CV" },
  { value: "CZK", label: "Czech Republic Koruna", flag: "CZ" },
  { value: "DJF", label: "Djiboutian Franc", flag: "DJ" },
  { value: "DKK", label: "Danish Krone", flag: "DK" },
  { value: "DOP", label: "Dominican Peso", flag: "DM" },
  { value: "DZD", label: "Algerian Dinar", flag: "DZ" },
  { value: "EGP", label: "Egyptian Pound", flag: "EG" },
  { value: "ERN", label: "Eritrean Nakfa", flag: "ER" },
  { value: "ETB", label: "Ethiopian Birr", flag: "ET" },
  { value: "EUR", label: "Euro", flag: "EU" },
  { value: "FJD", label: "Fijian Dollar", flag: "FJ" },
  { value: "FKP", label: "Falkland Islands Pound", flag: "FK" },
  { value: "GBP", label: "British Pound Sterling", flag: "GB" },
  { value: "GEL", label: "Georgian Lari", flag: "GE" },
  { value: "GGP", label: "Guernsey Pound", flag: "GG" },
  { value: "GHS", label: "Ghanaian Cedi", flag: "GH" },
  { value: "GIP", label: "Gibraltar Pound", flag: "GI" },
  { value: "GMD", label: "Gambian Dalasi", flag: "GM" },
  { value: "GNF", label: "Guinean Franc", flag: "GN" },
  { value: "GTQ", label: "Guatemalan Quetzal", flag: "GT" },
  { value: "GYD", label: "Guyanaese Dollar", flag: "GY" },
  { value: "HKD", label: "Hong Kong Dollar", flag: "HK" },
  { value: "HNL", label: "Honduran Lempira", flag: "HN" },
  { value: "HRK", label: "Croatian Kuna", flag: "HR" },
  { value: "HTG", label: "Haitian Gourde", flag: "HT" },
  { value: "HUF", label: "Hungarian Forint", flag: "HU" },
  { value: "IDR", label: "Indonesian Rupiah", flag: "ID" },
  { value: "ILS", label: "Israeli New Sheqel", flag: "IL" },
  { value: "IMP", label: "Manx pound", flag: "IM" },
  { value: "INR", label: "Indian Rupee", flag: "IN" },
  { value: "IQD", label: "Iraqi Dinar", flag: "IQ" },
  { value: "IRR", label: "Iranian Rial", flag: "IR" },
  { value: "ISK", label: "Icelandic Kr\u00f3na", flag: "IS" },
  { value: "JEP", label: "Jersey Pound", flag: "JE" },
  { value: "JMD", label: "Jamaican Dollar", flag: "JM" },
  { value: "JOD", label: "Jordanian Dinar", flag: "JO" },
  { value: "JPY", label: "Japanese Yen", flag: "JP" },
  { value: "KES", label: "Kenyan Shilling", flag: "KE" },
  { value: "KGS", label: "Kyrgystani Som", flag: "KG" },
  { value: "KHR", label: "Cambodian Riel", flag: "KH" },
  { value: "KMF", label: "Comorian Franc", flag: "KM" },
  { value: "KPW", label: "North Korean Won", flag: "KP" },
  { value: "KRW", label: "South Korean Won", flag: "KR" },
  { value: "KWD", label: "Kuwaiti Dinar", flag: "KW" },
  { value: "KYD", label: "Cayman Islands Dollar", flag: "KY" },
  { value: "KZT", label: "Kazakhstani Tenge", flag: "KZ" },
  { value: "LAK", label: "Laotian Kip", flag: "LA" },
  { value: "LBP", label: "Lebanese Pound", flag: "LB" },
  { value: "LKR", label: "Sri Lankan Rupee", flag: "LK" },
  { value: "LRD", label: "Liberian Dollar", flag: "LR" },
  { value: "LSL", label: "Lesotho Loti", flag: "LS" },
  { value: "LTL", label: "Lithuanian Litas", flag: "LT" },
  { value: "LVL", label: "Latvian Lats", flag: "LV" },
  { value: "LYD", label: "Libyan Dinar", flag: "LY" },
  { value: "MAD", label: "Moroccan Dirham", flag: "MA" },
  { value: "MDL", label: "Moldovan Leu", flag: "MD" },
  { value: "MGA", label: "Malagasy Ariary", flag: "MG" },
  { value: "MKD", label: "Macedonian Denar", flag: "MK" },
  { value: "MMK", label: "Myanma Kyat", flag: "MM" },
  { value: "MNT", label: "Mongolian Tugrik", flag: "MN" },
  { value: "MOP", label: "Macanese Pataca", flag: "MO" },
  { value: "MRO", label: "Mauritanian Ouguiya", flag: "MR" },
  { value: "MUR", label: "Mauritian Rupee", flag: "MU" },
  { value: "MVR", label: "Maldivian Rufiyaa", flag: "MV" },
  { value: "MWK", label: "Malawian Kwacha", flag: "MW" },
  { value: "MXN", label: "Mexican Peso", flag: "MX" },
  { value: "MYR", label: "Malaysian Ringgit", flag: "MY" },
  { value: "MZN", label: "Mozambican Metical", flag: "MZ" },
  { value: "NAD", label: "Namibian Dollar", flag: "NA" },
  { value: "NGN", label: "Nigerian Naira", flag: "NG" },
  { value: "NIO", label: "Nicaraguan C\u00f3rdoba", flag: "NI" },
  { value: "NOK", label: "Norwegian Krone", flag: "NO" },
  { value: "NPR", label: "Nepalese Rupee", flag: "NP" },
  { value: "NZD", label: "New Zealand Dollar", flag: "NZ" },
  { value: "OMR", label: "Omani Rial", flag: "OM" },
  { value: "PAB", label: "Panamanian Balboa", flag: "PA" },
  { value: "PEN", label: "Peruvian Nuevo Sol", flag: "PE" },
  { value: "PGK", label: "Papua New Guinean Kina", flag: "PG" },
  { value: "PHP", label: "Philippine Peso", flag: "PH" },
  { value: "PKR", label: "Pakistani Rupee", flag: "PK" },
  { value: "PLN", label: "Polish Zloty", flag: "PL" },
  { value: "PYG", label: "Paraguayan Guarani", flag: "PY" },
  { value: "QAR", label: "Qatari Rial", flag: "QA" },
  { value: "RON", label: "Romanian Leu", flag: "RO" },
  { value: "RSD", label: "Serbian Dinar", flag: "RS" },
  { value: "RUB", label: "Russian Ruble", flag: "RU" },
  { value: "RWF", label: "Rwandan Franc", flag: "RW" },
  { value: "SAR", label: "Saudi Riyal", flag: "SA" },
  { value: "SBD", label: "Solomon Islands Dollar", flag: "SB" },
  { value: "SCR", label: "Seychellois Rupee", flag: "SC" },
  { value: "SDG", label: "Sudanese Pound", flag: "SD" },
  { value: "SEK", label: "Swedish Krona", flag: "SE" },
  { value: "SGD", label: "Singapore Dollar", flag: "SG" },
  { value: "SHP", label: "Saint Helena Pound", flag: "SH" },
  { value: "SLL", label: "Sierra Leonean Leone", flag: "SL" },
  { value: "SOS", label: "Somali Shilling", flag: "SO" },
  { value: "SRD", label: "Surinamese Dollar", flag: "SR" },
  {
    value: "STD",
    label: "S\u00e3o Tom\u00e9 and Pr\u00edncipe Dobra",
    flag: "ST",
  },
  { value: "SVC", label: "Salvadoran Col\u00f3n", flag: "SV" },
  { value: "SYP", label: "Syrian Pound", flag: "SY" },
  { value: "SZL", label: "Swazi Lilangeni", flag: "SZ" },
  { value: "THB", label: "Thai Baht", flag: "TH" },
  { value: "TJS", label: "Tajikistani Somoni", flag: "TJ" },
  { value: "TMT", label: "Turkmenistani Manat", flag: "TM" },
  { value: "TND", label: "Tunisian Dinar", flag: "TN" },
  { value: "TOP", label: "Tongan Pa\u02bbanga", flag: "TO" },
  { value: "TRY", label: "Turkish Lira", flag: "TR" },
  { value: "TTD", label: "Trinidad and Tobago Dollar", flag: "TT" },
  { value: "TWD", label: "New Taiwan Dollar", flag: "TW" },
  { value: "TZS", label: "Tanzanian Shilling", flag: "TZ" },
  { value: "UAH", label: "Ukrainian Hryvnia", flag: "UA" },
  { value: "UGX", label: "Ugandan Shilling", flag: "UG" },
  { value: "USD", label: "United States Dollar", flag: "US" },
  { value: "UYU", label: "Uruguayan Peso", flag: "UY" },
  { value: "UZS", label: "Uzbekistan Som", flag: "UZ" },
  { value: "VEF", label: "Venezuelan Bol\u00edvar Fuerte", flag: "VE" },
  { value: "VND", label: "Vietnamese Dong", flag: "VN" },
  { value: "VUV", label: "Vanuatu Vatu", flag: "VU" },
  { value: "WST", label: "Samoan Tala", flag: "WS" },
  { value: "XAF", label: "CFA Franc BEAC", flag: "XA" },
  { value: "XAG", label: "Silver (troy ounce)", flag: "XA" },
  { value: "XAU", label: "Gold (troy ounce)", flag: "XA" },
  { value: "XCD", label: "East Caribbean Dollar", flag: "XC" },
  { value: "XDR", label: "Special Drawing Rights", flag: "XD" },
  { value: "XOF", label: "CFA Franc BCEAO", flag: "XO" },
  { value: "XPF", label: "CFP Franc", flag: "XP" },
  { value: "YER", label: "Yemeni Rial", flag: "YE" },
  { value: "ZAR", label: "South African Rand", flag: "ZA" },
  { value: "ZMK", label: "Zambian Kwacha (pre-2013)", flag: "ZM" },
  { value: "ZMW", label: "Zambian Kwacha", flag: "ZM" },
  { value: "ZWL", label: "Zimbabwean Dollar", flag: "ZW" },
];
